// Property-specific form styles (extends shared form styles)
import { StyleSheet } from 'react-native';
import { sharedFormStyles } from '@/components/common/admin/desktop/sharedFormStyles';
import { ADMIN_COLORS } from '@/constants/admin';

export const propertyFormStyles = StyleSheet.create({
  // Import all shared styles
  ...sharedFormStyles,
  
  // Property-specific button container variant
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 24,
    paddingBottom: 32,
    gap: 12,
  },
  
  // Override button with default background
  button: {
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 44,
    minWidth: 120,
    backgroundColor: ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND,
  },
  
  // Additional button variants
  buttonDisabled: {
    opacity: 0.5,
  },
  buttonText: {
    color: ADMIN_COLORS.BUTTON.PRIMARY_TEXT,
    fontSize: 14,
    fontWeight: '600',
  },
  
  // Property-specific: Maintenance Schedule Styles
  // Maintenance Schedule Styles
  maintenanceDay: {
    marginBottom: 20,
  },
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 2,
    borderColor: ADMIN_COLORS.BORDER,
    borderRadius: 4,
    marginRight: 12,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  checkboxChecked: {
    borderColor: ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND,
    backgroundColor: ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND,
  },
  checkboxInner: {
    width: 10,
    height: 10,
    backgroundColor: '#FFFFFF',
    borderRadius: 2,
  },
  dayLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.PRIMARY,
  },
  timePickersRow: {
    flexDirection: 'row',
    gap: 12,
    marginLeft: 32,
  },
  timePicker: {
    flex: 1,
  },
  timeLabel: {
    fontSize: 12,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.SECONDARY,
    marginBottom: 6,
  },
  timeInput: {
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    borderRadius: 8,
    padding: 10,
    fontSize: 14,
    color: ADMIN_COLORS.TEXT.PRIMARY,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
});

